document.addEventListener("DOMContentLoaded", function () {
    // Handle all video sections
    const sections = document.querySelectorAll(".video-tutorials-section");

    sections.forEach(function (section) {
        const sectionId = section.getAttribute("data-section-id");
        const toggleButton = section.querySelector(`.toggleButton[data-section-id="${sectionId}"]`);
        const searchInput = section.querySelector(`.searchInput[data-section-id="${sectionId}"]`);
        const tabNav = section.querySelector(".featured-products-tabs"); // Select tab navigation
        const allTabs = section.querySelectorAll(".tab-pane");
        const allVideoBlocks = section.querySelectorAll(".video-block");
        let isExpanded = false;
        let lastSelectedTab = null; // Variable to store the last selected tab

        // Function to toggle video blocks in the active tab
        function toggleVideoBlocks(activeTab) {
            const videoBlocks = activeTab.querySelectorAll(".video-block");
            videoBlocks.forEach((block, index) => {
                block.style.display = index >= 3 ? "none" : "block";
            });
        }

        // Initial state: find the first open tab
        const initialActiveTab = section.querySelector(".tab-pane.open");
        if (initialActiveTab) {
            toggleVideoBlocks(initialActiveTab);
            lastSelectedTab = initialActiveTab; // Store the initial tab as the last selected tab
        }

        // Toggle 'See More' and 'See Less' functionality
        if (toggleButton) {
            toggleButton.addEventListener("click", function () {
                const activeTab = section.querySelector(".tab-pane.open");
                const videoBlocks = activeTab.querySelectorAll(".video-block");

                if (!isExpanded) {
                    // Show all blocks within the active tab
                    videoBlocks.forEach((block) => block.style.display = "block");
                    toggleButton.textContent = "See Less";
                    isExpanded = true;
                } else {
                    // Show only the first 3 blocks within the active tab
                    videoBlocks.forEach((block, index) => {
                        block.style.display = index >= 3 ? "none" : "block";
                    });
                    toggleButton.textContent = "See More";
                    isExpanded = false;
                }
            });
        }

        // **Fuzzy Search Function**
        function fuzzySearchArray(titles, query) {
            query = query.toLowerCase();
            const queryWords = query.split(/\s+/); // Split query into words

            return titles.filter(title => {
                const titleWords = title.toLowerCase().split(/\s+/); // Split title into words
                return queryWords.every(word => 
                    titleWords.some(titleWord => titleWord.includes(word))
                );
            });
        }

        // **Search functionality across ALL tabs**
        if (searchInput) {
            searchInput.addEventListener("input", function () {
                const query = searchInput.value.toLowerCase();

                // Get all video block titles
                const titles = Array.from(allVideoBlocks).map(block => block.getAttribute("data-title") || "");

                // Get matched titles using fuzzy search
                const matchedTitles = fuzzySearchArray(titles, query);

                let anyMatch = false;

                allVideoBlocks.forEach((block) => {
                    const blockTitle = block.getAttribute("data-title") || "";
                    if (matchedTitles.includes(blockTitle)) {
                        block.style.display = "block";
                        anyMatch = true;
                    } else {
                        block.style.display = "none";
                    }
                });

                // Hide tab navigation and toggle button when searching
                if (query) {
                    tabNav.classList.add("d-none");
                    toggleButton.style.display = "none";
                    
                    // Show all tabs so matched results can be visible
                    allTabs.forEach(tab => tab.classList.add("open"));
                } else {
                    // Reset everything when search is cleared
                    tabNav.classList.remove("d-none");

                    // Restore only the last selected tab
                    allTabs.forEach(tab => {
                        tab.classList.remove("open");
                    });

                    // Show only the last selected tab
                    if (lastSelectedTab) {
                        lastSelectedTab.classList.add("open");
                        toggleVideoBlocks(lastSelectedTab); // Ensure to reset video blocks for that tab
                    }

                    toggleButton.style.display = "inline-block";
                    toggleButton.textContent = "See More";
                    isExpanded = false;
                }
            });
        }

        // Event listener for tab change
        const tabLinks = section.querySelectorAll(".tablink a");
        tabLinks.forEach(tab => {
            tab.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent default anchor behavior

                // Remove 'open' class from all tab-panes within the current section
                allTabs.forEach(tabPane => tabPane.classList.remove("open"));

                // Apply 'open' class to the targeted tab-pane
                const targetTab = section.querySelector(this.getAttribute("data-tabcontent"));
                if (targetTab) {
                    targetTab.classList.add("open");

                    // Store the last selected tab
                    lastSelectedTab = targetTab;

                    // Reset video blocks visibility for the newly active tab
                    toggleVideoBlocks(targetTab);

                    // Reset toggle button state
                    toggleButton.textContent = "See More";
                    isExpanded = false;
                }
            });
        });
    });
});
